export const enum contextualSearchStatus {
    ContextualSearch = "ContextualSearch",
    NonContextualSearch = "NonContextualSearch"
}

export const enum searchStatus {
    New = "New",
    Processing = "Processing",
    Done = "Done",
    Inactive = "Inactive"
}

export enum DynamoDBStatus {
    NotConfigured = "Recent Activity is not configured",
    NotWorking = "Recent Activity is not working",
    Working = "Recent Activity is configured and working",
}

export enum ChatHistoryLoadingState {
    Loading = "loading",
    Success = "success",
    Fail = "fail",
    NotStarted = "notStarted"
}

export enum UserRole {
    Admin = "admin",
    User = "user",
    NhgUser = "nhg_user",
    LtaUser = "lta_user",
    SsoeUser = "ssoe_user"
}

export const CitationDisplayTypes = {
    FULL: '1',                       // Type 1: main title, title, url (decode)
    MAIN_TITLE_ONLY: '2', // Type 2: main title
    MAIN_TITLE_WITH_URL: '3', // Type 3: main title, url (decode)
    MAIN_TITLE_WITH_SUBTITLE: '4', // Type 4: main title, title
    CUSTOM_URL: '5',           // Type 5: main title, title, custom url
};